import { MailWizzInstanceService } from './mail-wizz-instance.serive';

export class CampaignService extends MailWizzInstanceService {
    protected getResourceUrl() { return 'api/campaigns' }

    public generateCampaignLink(campaignId: string) : string {
        const activeMailWizz = this.getMailWizzInstance()
        if (!activeMailWizz) return '/#'
        return `${new URL('/customer/index.php/campaigns', activeMailWizz.url).toString()}/${campaignId}/overview`
    }
}

export const campaignService = new CampaignService();